<template>
<div class="prbg-white prrounded prborder p-3 " style="letter-spacing: 0;">
  <div class="list">
        <div class="card mb-3" v-for="item in pollList" :key="item.id">
          <span class="position-absolute top-0 end-100 translate-middle badge rounded-pill" style="transform: translate(-110%, -33%) !important;" :class="{'bg-info': item.state == 1, 'bg-success': item.state == 2, 'bg-danger': item.state == 3}">{{ item.state == 1 ? 'در حال بررسی' : item.state == 2 ? 'تایید شده' : 'رد شده' }}</span>
            <div class="card-body align-self-center d-flex flex-column flex-start justify-content-between w-100">
                <p class="mb-0">{{ item.vote }}</p>
                <p class="mb-0">خدمات : {{ item.evaluation.split('-')[0] == 0 ? '-' : 1 ? 'خوب' : 2 ? 'متوسط' : 'ضعیف'}}</p>
                <p class="mb-0">پیک : {{ item.evaluation.split('-')[1] == 0 ? '-' : 1 ? 'خوب' : 2 ? 'متوسط' : 'ضعیف' }}</p>
                <p class="mb-0">بسته بندی : {{ item.evaluation.split('-')[2] == 0 ? '-' : 1 ? 'خوب' : 2 ? 'متوسط' : 'ضعیف' }}</p>
                <p class="mb-0 text-muted text-small ">{{ item.time }}</p>
                <p v-if="item.site_ans" ><span style="color: rgb(255, 0, 166);">پاسخ راداَپ :  </span>{{ item.site_ans }}</p>
                <p v-if="item.supplier_ans"><span style="color: rgb(255, 0, 166);">پاسخ فروشگاه : </span>{{ item.supplier_ans }}</p>
            </div>
            <div class="w-100">
              <button class="btn btn-light m-1 p-1 position-relative text-dark" disabled style="font-size: 12px;" v-for="product in item.basket" >
                <span class="position-absolute top-0 translate-middle badge rounded-pill  text-dark" style="left:15px;transform: translate(-110%, -33%) !important;font-weight: 700;" v-if="product.count > 1" >{{convertToPersian(String(product.count)) }}</span>
                {{ product.name }}
              </button>
            </div>
        </div>
      </div>
</div>
</template>

<script setup>
import { ref } from "@vue/reactivity";
import { convertToPersian } from "@/composables/digits";
let pollList = ref();
let userInfo = ref();
getPolls();
async function getPolls(){
  getLocalStorage() 
  let response = await fetch('https://radap.ir/Backend/api/account/poll/get.php?token='+userInfo.value[0].token)
  let data = await response.json()
    pollList.value = data;
}
function getLocalStorage() {
  userInfo.value = JSON.parse(localStorage.getItem('userInfo'));
}
</script>

<style scoped>
/* @import "../../../../assets/css/account.css";
table thead tr th{
  text-align: right;
} */
</style>